var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPage = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#B2B2B2",
  fillRule: "evenodd",
  stroke: "#B2B2B2",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.694 2.664a.728.728 0 0 0-.735.72v17.28c0 .397.33.72.735.72h12.734a.72.72 0 0 0 .735-.72V3.384c0-.397-.33-.72-.735-.72H5.694zm12.734 19.2H5.694a1.213 1.213 0 0 1-1.225-1.2V3.384c0-.662.55-1.2 1.225-1.2h12.734c.676 0 1.225.538 1.225 1.2v17.28c0 .662-.55 1.2-1.225 1.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.773 2.664v1.853c0 .148.12.264.275.264h2.115V3.384c0-.397-.33-.72-.735-.72h-1.655zm2.88 2.597h-2.605a.755.755 0 0 1-.765-.744V2.184h2.145c.676 0 1.225.538 1.225 1.2v1.877zM17.047 11.946H7.075a.247.247 0 0 1-.245-.25c0-.138.11-.25.245-.25h9.972c.135 0 .245.112.245.25s-.11.25-.245.25M17.047 13.97H7.075a.247.247 0 0 1-.245-.25c0-.137.11-.25.245-.25h9.972c.135 0 .245.113.245.25 0 .139-.11.25-.245.25M17.047 16.084H7.075a.247.247 0 0 1-.245-.25c0-.138.11-.25.245-.25h9.972c.135 0 .245.112.245.25s-.11.25-.245.25M17.068 18.95h-3.265a.248.248 0 0 1-.245-.25c0-.139.11-.25.245-.25h3.265c.135 0 .245.111.245.25 0 .137-.11.25-.245.25M10.336 9.046H7.071a.248.248 0 0 1-.245-.25c0-.138.11-.25.245-.25h3.265c.135 0 .245.112.245.25s-.11.25-.245.25"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/page.4d5c700c34a7b742a72cffec89313969.svg";